var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAwsGlue16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/16/Arch_AWS-Glue_16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D27A8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A166FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/16/Arch_AWS-Glue_16",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/16/Analytics",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.5088141,18.003 L12.5088141,16.5 L11.5072115,16.5 L11.5072115,17.997 L10.9052484,17.199 L10.1059696,17.801 L11.6133814,19.801 C11.7085337,19.926 11.8567708,20 12.0140224,20 L12.015024,20 C12.1722756,20 12.3215144,19.925 12.4146635,19.799 L13.9110577,17.799 L13.1097756,17.201 L12.5088141,18.003 Z M15.1270032,10.125 C14.0042067,10.385 12.6700721,10.488 12,10.488 C11.3309295,10.488 10.0008013,10.385 8.87900641,10.127 L11.4220753,13.9 C11.4781651,13.983 11.5072115,14.08 11.5072115,14.18 L11.5072115,15.088 C11.8207131,15.141 12.2123397,15.142 12.5088141,15.094 L12.5088141,14.18 C12.5088141,14.081 12.5378606,13.984 12.5939503,13.901 L15.1270032,10.125 Z M16.911859,9.253 L16.9148638,9.255 L13.5104167,14.332 L13.5104167,15.471 C13.5104167,15.668 13.3942308,15.847 13.2139423,15.927 C12.9004407,16.067 12.4717548,16.128 12.0440705,16.128 C11.5853365,16.128 11.1286058,16.057 10.8211138,15.936 C10.6308093,15.86 10.505609,15.676 10.505609,15.471 L10.505609,14.332 L7.08513622,9.256 L7.08814103,9.254 C7.03705929,9.167 7,9.076 7,8.977 C7,8.655 7,7.985 10.4685497,7.838 L10.5116186,8.837 C9.64823718,8.874 9.03525641,8.948 8.61959135,9.024 C9.3828125,9.251 10.6478365,9.488 12,9.488 C13.2790465,9.488 14.4789663,9.276 15.2502003,9.062 C15.0188301,9.022 14.7554087,8.987 14.4749599,8.966 L14.5490785,7.969 C16.1756811,8.09 17,8.429 17,8.977 C17,9.076 16.9639423,9.166 16.911859,9.253 L16.911859,9.253 Z M9.00320513,7 L10.0048077,7 C10.28125,7 10.505609,6.776 10.505609,6.5 L10.505609,5.5 C10.505609,5.224 10.28125,5 10.0048077,5 L9.00320513,5 C8.72676282,5 8.50240385,5.224 8.50240385,5.5 L8.50240385,6.5 C8.50240385,6.776 8.72676282,7 9.00320513,7 L9.00320513,7 Z M11.5072115,8.5 L11.5072115,7.5 C11.5072115,7.224 11.7315705,7 12.0080128,7 L13.0096154,7 C13.2860577,7 13.5104167,7.224 13.5104167,7.5 L13.5104167,8.5 C13.5104167,8.776 13.2860577,9 13.0096154,9 L12.0080128,9 C11.7315705,9 11.5072115,8.776 11.5072115,8.5 L11.5072115,8.5 Z",
    id: "AWS-Glue_Icon_16_Squid",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAwsGlue16);
export default __webpack_public_path__ + "static/media/Arch_AWS-Glue_16.a9dd5d62c62a17c0e6ca2bc7efcf6ac2.svg";
export { ForwardRef as ReactComponent };